var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",on:{"click":function($event){return _vm.onClick()}}},[_c('div',{staticClass:"icon"}),_vm._v(" "),_c('div',{staticClass:"text"},[_vm._v("\n    "+_vm._s(_vm.converting ? "PPT转换中..." : _vm.getText("导入PPT"))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"tag"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-690086bd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/scenes/fromPPT.vue
// module id = null
// module chunks = 